<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VnjcNx/tc-custom/9781466891975.jpg?1722338486277" alt="This image is the cover for the book Emperor's Railroad, The Dreaming Cities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emperor's Railroad, The Dreaming Cities
      </h1>
      <p class="bookDescription body article font2">
        <p>Global war devastated the environment, a zombie-like plague wiped out much of humanity, and civilization as we once understood it came to a standstill. But that was a thousand years ago, and the world is now a very different place.<br/><br/>Conflict between city states is constant, superstition is rife, and machine relics, mutant creatures and resurrected prehistoric beasts trouble the land. Watching over all are the silent Dreaming Cities. Homes of the angels, bastion outposts of heaven on Earth. Or so the church claims. Very few go in, and nobody ever comes out. <br/><br/>Until now…<br/><br/><br/>"Haley serves up equal helpings of horror, fantasy adventure, and SF in this stark, intriguing story of a ruined Earth where the remaining humans are determined to survive." - Publishers Weekly<br/><br/>“Entertaining and exciting... If grim-dark is your thing, then this is a great read for you.” – Bull-Spec<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Guy Haley
      </h2>
      
      <p class="authorDescription body article">A prolific freelance author and journalist, Guy Haley is the author of <I>Reality 36, </I>the Warhammer 40,000 novels <I>Valedor </I>and <I>Baneblade</I>, among others. He lives in Yorkshire with his wife and son.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tor.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5647eab4